module.exports = __webpack_public_path__ + "static/UltimateGuitar-91f478de8d74fa4bb7762a57d6f2763b.png";